const typography = {
  fonSize: 12,
  fontFamily: ['Inter', 'Source Sans Pro', 'sans-serif'].join(','),
  h1: {
    fontFamily: ['Inter', 'Source Sans Pro', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: 34,
    letterSpacing: '-0.24px',
  },
  h2: {
    fontFamily: ['Inter', 'Source Sans Pro', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: 28,
    letterSpacing: '-0.24px',
  },
  h3: {
    fontFamily: ['Inter', 'Source Sans Pro', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: 24,
    letterSpacing: '-0.06px',
  },
  h4: {
    fontFamily: ['Inter', 'Source Sans Pro', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: 20,
    letterSpacing: '-0.06px',
  },
  h5: {
    fontFamily: ['Inter', 'Source Sans Pro', 'sans-serif'].join(','),
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px',
  },
  h6: {
    fontFamily: ['Inter', 'Source Sans Pro', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: 14,
    letterSpacing: '-0.05px',
  },
  overline: {
    fontWeight: 500,
  },
};

export default typography;
